import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-db34ffae")

_pushScopeId("data-v-db34ffae")
const _hoisted_1 = { class: "CompletedFTLCar" }
const _hoisted_2 = { class: "CompletedFTLCar__header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", { class: "header__title" }, "Машина", -1)
const _hoisted_4 = { class: "CompletedFTLCar__body" }
const _hoisted_5 = { class: "body__row" }
const _hoisted_6 = { class: "body__col" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "col__subtext" }, "Грузоподъёмность", -1)
const _hoisted_8 = { class: "col__text" }
const _hoisted_9 = { class: "body__col" }
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "col__subtext" }, "Кубатура", -1)
const _hoisted_11 = { class: "col__text" }
const _hoisted_12 = /*#__PURE__*/_createVNode("sup", null, "3", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Не указана")
const _hoisted_14 = { class: "body__col" }
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "col__subtext" }, "Способ оплаты", -1)
const _hoisted_16 = { class: "col__text" }
const _hoisted_17 = { class: "body__row" }
const _hoisted_18 = { class: "body__col" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "col__subtext" }, "Температурный режим", -1)
const _hoisted_20 = { class: "col__text" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Не указан")
const _hoisted_22 = { class: "body__col" }
const _hoisted_23 = /*#__PURE__*/_createVNode("p", { class: "col__subtext" }, "Тип погрузки", -1)
const _hoisted_24 = { class: "col__text" }
const _hoisted_25 = { class: "body__col" }
const _hoisted_26 = /*#__PURE__*/_createVNode("p", { class: "col__subtext" }, "Объявленная стоимость", -1)
const _hoisted_27 = { class: "col__text" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Не указана")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_edit = _resolveComponent("icon-edit")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.blocked)
        ? (_openBlock(), _createBlock(_component_icon_edit, {
            key: 0,
            class: "header__edit",
            onClick: _ctx.emitReset
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode("p", _hoisted_8, _toDisplayString(_ctx.car.liftingCapacity.load_capacity), 1)
        ]),
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode("p", _hoisted_11, [
            (_ctx.car.cubicCapacity)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.car.cubicCapacity) + " м", 1),
                  _hoisted_12
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _hoisted_13
                ], 64))
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode("p", _hoisted_16, _toDisplayString(_ctx.car.paymentMethod.name), 1)
        ])
      ]),
      _createVNode("div", _hoisted_17, [
        _createVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode("p", _hoisted_20, [
            (_ctx.car.temperatureRegim)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.car.temperatureRegim), 1)
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _hoisted_21
                ], 64))
          ])
        ]),
        _createVNode("div", _hoisted_22, [
          _hoisted_23,
          _createVNode("p", _hoisted_24, _toDisplayString(_ctx.car.loadingType.name), 1)
        ]),
        _createVNode("div", _hoisted_25, [
          _hoisted_26,
          _createVNode("p", _hoisted_27, [
            (_ctx.car.declaredPrice)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.car.declaredPrice) + " тг.", 1)
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _hoisted_28
                ], 64))
          ])
        ])
      ])
    ])
  ]))
})